import React, { Component } from "react";
import { Bar, Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels"; // Import the plugin

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  ChartDataLabels // Register the plugin
);

class Charts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      barChartData: {
        labels: ["January", "February", "March"],
        datasets: [
          {
            label: "Opening",
            data: [150, 200, 160],
            backgroundColor: "rgba(137, 121, 255, 0.6)", // Purple color for Opening
            borderColor: "rgba(137, 121, 255, 1)",
            borderWidth: 1,
          },
          {
            label: "Hired",
            data: [127, 179, 123],
            backgroundColor: "rgba(255, 146, 138, 0.6)", // Red color for Hired
            borderColor: "rgba(255, 146, 138, 1)",
            borderWidth: 1,
          },
        ],
      },

      pieChartData: {
        labels: ["Application Received", "Onboarding", "Interviews"],
        datasets: [
          {
            data: [45.0, 10.0, 45.0],
            backgroundColor: ["#3CC3DF", "#8979FF", "#FF928A"],
            hoverOffset: 4,
          },
        ],
      },
    };
  }

  render() {
    return (
      <>
        <div
          className="mt-5 mb-5"
          style={{ backgroundColor: "#F1F1F1", borderRadius: "10px" }}
        >
          <div className="d-flex flex-column flex-lg-row gap-3">
            {/* Pie Chart Section */}
            <div style={{ flex: "1", minWidth: "300px", height: "500px" }}>
              <h5 className="fw-bold mb-3">Recruitment Overview</h5>
              <div
                className="card shadow-sm"
                style={{
                  padding: "20px",
                  borderRadius: "10px",
                  backgroundColor: "white",
                  height: "100%",
                }}
              >
                <Pie
                  data={this.state.pieChartData}
                  options={{
                    responsive: true,
                    maintainAspectRatio: false, // Keep aspect ratio consistent
                    plugins: {
                      legend: {
                        position: "top", // Move the legend to the bottom
                        labels: {
                          boxWidth: 8, // Adjust the width of the legend color box
                          boxHeight: 8, // Adjust the height of the legend color box
                        },
                      },
                      datalabels: {
                        color: "black",
                        formatter: (value, ctx) => {
                          let sum = ctx.chart.data.datasets[0].data.reduce(
                            (a, b) => a + b,
                            0
                          );
                          let percentage = ((value / sum) * 100).toFixed(2);
                          return `${percentage}%`; // Display percentage with 2 decimal places
                        },
                        font: {
                          weight: "normal",
                          size: 13,
                        },
                        anchor: "end",
                        align: "start",
                        offset: 10, // Adjust offset to move labels outside the pie chart
                      },
                    },
                  }}
                  style={{
                    borderRadius: "10px",
                    width: "50%", // Adjust width percentage to make the pie chart smaller
                    height: "50%", // Adjust height percentage to make the pie chart smaller
                    margin: "0", // Center the pie chart
                    padding: "50px",
                  }}
                />
              </div>
            </div>

            {/* Bar Chart Section */}
            <div style={{ flex: "1", minWidth: "300px", height: "500px" }}>
              <h5 className="fw-bold mb-3">Opening and Hired Rate</h5>
              <div
                className="card shadow-sm"
                style={{
                  padding: "20px",
                  borderRadius: "10px",
                  backgroundColor: "white",
                  height: "100%",
                }}
              >
                <Bar
                  data={this.state.barChartData}
                  options={{
                    responsive: true,
                    maintainAspectRatio: false, // Keep aspect ratio consistent
                    scales: {
                      y: {
                        beginAtZero: true,
                        min: 0, // Ensure the y-axis starts at 0
                        max: 200, // Adjust max value for taller bars
                        ticks: {
                          stepSize: 50, // Customize step size to control the scale of the y-axis
                        },
                      },
                    },
                    plugins: {
                      legend: {
                        position: "bottom", // Move the legend to the bottom
                        labels: {
                          boxWidth: 8, // Adjust the width of the legend color box
                          boxHeight: 8, // Adjust the height of the legend color box
                        },
                      },
                      tooltip: {
                        callbacks: {
                          label: function (context) {
                            return context.dataset.label + ": " + context.raw;
                          },
                        },
                      },
                      datalabels: {
                        display: true,
                        color: "black", // Set label color
                        align: "top", // Align labels to the top of the bars
                        anchor: "top", // Place the label at the start of the top of the bar
                        font: {
                          weight: "normal",
                          size: 10,
                        },
                        verticalAlign: "top", // Position the label inside the bar at the top
                        formatter: function (value) {
                          return value; // Display the value inside the bar
                        },
                      },
                    },
                  }}
                  style={{ width: "100%", height: "100%" }}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Charts;
